module.exports = __webpack_public_path__ + "fonts/Evogria Italic.f20f653b.otf";